/*
  COSNETIC -- "Kontakt os" page behaviour (2026-09-22).
  - FAQ groups keep one answer open at a time (like NYGHT's kontakt-os).
  - The search box filters every question/answer on the page live and highlights the hit.
  - Pills mark the group in view.
  - Deflection: the "what is it about?" select shows that topic's answers first; the form only
    unfolds after "I did not find it" (or straight away when the page loads with ?contact_posted /
    #kundeservice-form so a submitted form keeps its success/error banner visible).
*/
(function () {
  var root = document;

  /* single-open accordions */
  root.querySelectorAll('.cc-faqg').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var item = e.target;
      if (!item.open || !item.classList.contains('cc-faqg__item')) return;
      group.querySelectorAll('.cc-faqg__item[open]').forEach(function (o) { if (o !== item) o.open = false; });
    }, true);
  });

  /* search */
  var search = root.querySelector('[data-cc-search]');
  var hits = root.querySelector('[data-cc-hits]');
  function strip(el) { el.querySelectorAll('mark').forEach(function (m) { m.replaceWith(m.textContent); }); el.normalize(); }
  function mark(el, q) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      var i = t.nodeValue.toLowerCase().indexOf(q);
      if (i < 0) return;
      var m = document.createElement('mark'); m.textContent = t.nodeValue.substr(i, q.length);
      var after = t.splitText(i); after.nodeValue = after.nodeValue.substr(q.length);
      t.parentNode.insertBefore(m, after);
    });
  }
  if (search) {
    search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase(), total = 0;
      root.querySelectorAll('.cc-faqg').forEach(function (group) {
        var shown = 0;
        group.querySelectorAll('.cc-faqg__item').forEach(function (item) {
          var qEl = item.querySelector('.cc-faqg__q strong'), aEl = item.querySelector('.cc-faqg__a');
          strip(qEl); strip(aEl);
          var hit = !q || (qEl.textContent + ' ' + aEl.textContent).toLowerCase().indexOf(q) >= 0;
          item.hidden = !hit;
          if (hit && q.length >= 2) { mark(qEl, q); mark(aEl, q); item.open = true; }
          if (!q) item.open = false;
          shown += hit ? 1 : 0;
        });
        group.classList.toggle('is-empty', q && !shown);
        total += shown;
      });
      if (hits) hits.textContent = q ? (search.getAttribute('data-hits-label') || '{n}').replace('{n}', total) : '';
    });
  }

  /* pills follow scroll */
  var pills = root.querySelectorAll('.cc-pills__pill[href^="#"]');
  if (pills.length && 'IntersectionObserver' in window) {
    var byId = {};
    pills.forEach(function (p) { byId[p.getAttribute('href').slice(1)] = p; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        var p = byId[en.target.id]; if (p) p.classList.add('is-active');
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(byId).forEach(function (id) { var t = document.getElementById(id); if (t) io.observe(t); });
  }

  /* deflection */
  var block = root.querySelector('.cc-kc');
  if (!block) return;
  var select = block.querySelector('[data-cc-topic]');
  var hintsBox = block.querySelector('[data-cc-hints]');
  var hintsList = block.querySelector('[data-cc-hints-list]');
  var reveal = block.querySelector('[data-cc-reveal]');
  var form = block.querySelector('[data-cc-form]');
  var topicField = block.querySelector('[data-cc-topic-field]');
  var posted = /contact_posted=true|form_type=contact/.test(location.search + location.hash) || block.querySelector('.cc-kc__msg');
  function openItem(item) {
    var group = item.closest('.cc-faqg');
    group.querySelectorAll('.cc-faqg__item[open]').forEach(function (o) { o.open = false; });
    item.open = true;
    item.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function showForm() { if (form) { form.hidden = false; document.dispatchEvent(new Event('cc:reveal')); var first = form.querySelector('input:not([type=hidden])'); if (first) first.focus({ preventScroll: true }); } }
  if (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var anchor = opt.getAttribute('data-anchor');
      if (topicField) topicField.value = opt.textContent.trim();
      hintsList.innerHTML = '';
      var group = anchor ? document.getElementById(anchor) : null;
      if (group) {
        var items = group.querySelectorAll('.cc-faqg__item');
        Array.prototype.slice.call(items, 0, 4).forEach(function (item) {
          var li = document.createElement('li'); li.className = 'cc-kc__hint';
          var b = document.createElement('button'); b.type = 'button'; b.textContent = item.querySelector('.cc-faqg__q strong').textContent;
          b.addEventListener('click', function () { openItem(item); });
          li.appendChild(b); hintsList.appendChild(li);
        });
        hintsBox.classList.toggle('is-on', items.length > 0);
        if (reveal) reveal.hidden = false;
        if (form && !posted) form.hidden = true;
      } else {
        hintsBox.classList.remove('is-on');
        if (reveal) reveal.hidden = true;
        if (select.value) showForm();
      }
    });
  }
  block.querySelectorAll('[data-cc-yes]').forEach(function (b) { b.addEventListener('click', function () { hintsBox.classList.remove('is-on'); if (reveal) reveal.hidden = true; if (form) form.hidden = true; select.value = ''; var top = root.querySelector('.cc-kb') || document.body; top.scrollIntoView({ behavior: 'smooth' }); }); });
  block.querySelectorAll('[data-cc-no]').forEach(function (b) { b.addEventListener('click', showForm); });
  if (posted) showForm();
})();
